import { useCallback, useEffect, useRef } from 'react';

function useRecaptcha() {
  const script = useRef<HTMLScriptElement>(
    document.getElementById('recaptcha') as HTMLScriptElement,
  );

  useEffect(() => {
    if (script.current) return;
    script.current = document.createElement('script');
    script.current.src = `https://google.com/recaptcha/api.js?render=${process.env.REACT_APP_GOOGLE_RECAPTCHA}`;
    script.current.id = 'recaptcha';
    document.body.append(script.current);
  }, []);

  const getToken = useCallback((action = 'submit') => {
    return new Promise<string>((resolve, reject) => {
      if (!script.current) reject('Missing recaptcha');
      const g = (window as any).grecaptcha;
      g.ready(async () => {
        const token = await g.execute(process.env.REACT_APP_GOOGLE_RECAPTCHA, {
          action,
        });
        resolve(token);
      });
    });
  }, []);

  return { getToken };
}

export default useRecaptcha;
